import { type ReactElement } from 'react';

import styles from './content-card-reward.module.scss';
import { Font } from '@utmb/design-system/text/font';
import RunningStones from '@utmb/design-system/running-stone/RunningStones';
import { getColorStyle, getLoyaltyColor } from '@utmb/utils/colors';
import { LoyaltyLevelEnum } from '@utmb/types/enum/LoyaltyLevelEnum';
import MyUtmbPoints from '@utmb/design-system/my-utmb-points/MyUtmbPoints';
import { Image } from '@utmb/design-system/image/Image';
import { pIdToCloudinary } from '@utmb/utils/cloudinary';
import { CloudinaryTransformEnum } from '@utmb/types/cloudinary-transform.enum';
import { ColorTypesEnum } from '@utmb/types/colors';

export interface ContentCardRewardProps {
    type: 'STONES' | 'POINTS' | 'INDEX';
    quantity: number;
    loyaltyLevel?: LoyaltyLevelEnum;
}

export function ContentCardReward({ type, quantity, loyaltyLevel }: ContentCardRewardProps): ReactElement {
    return (
        <div className={styles.contentCardReward}>
            <div className={styles.symbol}>
                {type === 'STONES' ? (
                    <RunningStones quantity={quantity} size={50} />
                ) : type === 'POINTS' ? (
                    <MyUtmbPoints
                        quantity={quantity}
                        color={loyaltyLevel ? getLoyaltyColor(loyaltyLevel) : getColorStyle(ColorTypesEnum.SECONDARY)}
                        size={50}
                    />
                ) : (
                    <Image
                        objectFit="contain"
                        layout="fixed"
                        width={75}
                        height={15}
                        maxWidth={300}
                        image={pIdToCloudinary('/Common/categories/index_bg', 'UTMB Index Race')}
                        addOptions={[CloudinaryTransformEnum.TRIM]}
                    />
                )}
            </div>
            {type === 'INDEX' ? (
                <Font.OxaniumBold mobile="16" desktop="18" className={styles.plus}>
                    {quantity}
                </Font.OxaniumBold>
            ) : null}
        </div>
    );
}
